import React from 'react';
import { ContactInfo } from './contact/ContactInfo';
import { ContactForm } from './contact/ContactForm';
import { WhyBookWithUs } from './contact/WhyBookWithUs';

export const ContactSection = () => {
  return (
    <section id="contact" className="section-padding bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Book Your <span className="text-primary">Free Inspection</span>
          </h2>
          <p className="text-base sm:text-lg text-gray-600">
            Get in touch today for a no-obligation assessment of your roofing needs
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 max-w-6xl mx-auto">
          {/* Contact Information */}
          <div className="lg:col-span-2 space-y-6 sm:space-y-8">
            <div>
              <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">
                Contact Information
              </h3>
              <ContactInfo />
            </div>
            <WhyBookWithUs />
          </div>

          {/* Contact Form */}
          <div className="lg:col-span-3">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};
